export interface BillingRateInfoJSON {
  billingRate: string;
  billingUnit: string;
}

export default class BillingRateInfo {
  billingRate: string;
  billingUnit: string;

  constructor(billingRate: string, billingUnit: string) {
    this.billingRate = billingRate;
    this.billingUnit = billingUnit;
  }

  public static fromJSON(json: BillingRateInfoJSON): BillingRateInfo | undefined {
    if (!json) return;
    const { billingRate, billingUnit } = json;
    return new BillingRateInfo(billingRate, billingUnit);
  }

  public toJSON(): BillingRateInfoJSON {
    return {
      billingRate: this.billingRate.toString(),
      billingUnit: this.billingUnit.toString()
    };
  }
}
